import { OrderedSet, Record } from 'immutable';

import { FullBetSlipState } from '../types';
import type { Logout } from 'app/lib/auth/types';

import { StakeType } from 'app/lib/staking/constants';
import { logout } from 'app/redux/actions/auth';
import { INIT_ACTION } from 'app/redux/actions/init';

import {
  CLEANUP, Cleanup,
  REFRESH_AVAILABILITY, RefreshAvailability,
} from '../actions';
import {
  COMPLETE_REPLACE, CompleteReplace,
  DELETE_FROM_BET_SLIP, DeleteFromBetSlip,
  INSERT_IN_BET_SLIP, InsertInBetSlip,
} from '../actions/entries';
import {
  CHANGE_STAKE_TYPE_AMOUNT, ChangeStakeTypeAmount,
  UPDATE_CHECKED_STAKE_TYPE, UpdateCheckedStakeType,
} from '../actions/stakeTypes';
import { StakeTypeAmount } from '../records';
import { RecordOfStakeTypesState, StakeTypesState } from '../types/stakeTypes';
import express, { ExpressStakeTypeActions } from './stakeTypes/express';
import single, { SingleStakeTypeActions } from './stakeTypes/single';
import system, { SystemStakeTypeActions } from './stakeTypes/system';

// ---

const DEFAULT_GLOBAL_STATE = undefined;

export const initialState = Record<StakeTypesState>({
  single: single(undefined, INIT_ACTION),
  express: express(undefined, INIT_ACTION, DEFAULT_GLOBAL_STATE),
  system: system(undefined, INIT_ACTION),
  amount: StakeTypeAmount(),
  available: OrderedSet(),
  checked: StakeType.EXPRESS,
}, 'stakeTypes');

export type StakeTypesActions =
  | RefreshAvailability
  | InsertInBetSlip
  | DeleteFromBetSlip
  | CompleteReplace
  | UpdateCheckedStakeType
  | ChangeStakeTypeAmount
  | Cleanup
  | Logout;

// ---

export default function (
  state = initialState(),
  action: StakeTypesActions,
  globalState: FullBetSlipState,
): RecordOfStakeTypesState {
  switch (action.type) {
    case REFRESH_AVAILABILITY:
    case INSERT_IN_BET_SLIP:
    case DELETE_FROM_BET_SLIP:
    case COMPLETE_REPLACE:
      if (action.payload.availableStakeTypes) {
        state = state.set('available', action.payload.availableStakeTypes);
      }
  }

  state = state.update('single', (state) => single(state, action as SingleStakeTypeActions));

  state = state.update('express', (expressState) => {
    if (!state.available.has(StakeType.EXPRESS)) {
      return express(undefined, INIT_ACTION, DEFAULT_GLOBAL_STATE);
    }

    return express(expressState, action as ExpressStakeTypeActions, globalState);
  });

  state = state.update('system', (systemState) => {
    if (!state.available.has(StakeType.SYSTEM)) {
      return system(undefined, INIT_ACTION);
    }
    return system(systemState, action as SystemStakeTypeActions);
  });

  switch (action.type) {
    case UPDATE_CHECKED_STAKE_TYPE:
      return state.set('checked', action.payload.value);

    case CHANGE_STAKE_TYPE_AMOUNT:
      return state.update('amount', (amount) => amount.merge(action.payload));

    case logout.pending.toString():
      return state.set('amount', StakeTypeAmount());

    case CLEANUP:
      return initialState().set('checked', state.get('checked'));

    default:
      return state;
  }
}
